<template>
  <div>
    <DateOfBirth :value="profile" v-if="active" />

    <v-btn color="primary" @click="$emit('input')" :disabled="!profile.bornAt" block>
      Save
    </v-btn>
  </div>
</template>

<script>
import DateOfBirth from '@/components/candidate/profile/edit/details/DateOfBirth'

export default {
  components: { DateOfBirth },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
}
</script>
